/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Spacecraft Design component for Mission Operation
Author: Deimos Space UK

Version: 1.0
*/
import React, {useState, useEffect} from 'react'
import { Row, Col, Form } from 'react-bootstrap';
import style from '../MissionOperation.module.css'
import Select from 'react-select';
export default function SpacecraftDesign(props) {

  const [mass, setMass] = useState('')
  const [cross, setCross] = useState('')
  const [objectType, setObjectType] = useState('')
  const [architectureType, setArchitectureType] = useState('')

  useEffect(() => {
    if (props.step2 && props.step2[props.index] ){
      setMass(props.step2[props.index].SpacecraftDesign.mass)
    }

    if(props.step2 && props.step2[props.index]){
      setCross(props.step2[props.index].SpacecraftDesign.cross)
    }

    if(props.step2 && props.step2[props.index]){
      setObjectType(props.step2[props.index].SpacecraftDesign.objectType)
    }
    if(props.architectureType){
      setArchitectureType(props.architectureType)
    }
    
  }, [props])

  const launcherOptions = [
    { value: 'Rocket Body', label: 'Rocket Body' },
  ]

  const options = [
    { value: 'Payload', label: 'Payload' },
    { value: 'Rocket Body', label: 'Rocket Body' },
    { value: 'Payload Mission Related Object', label: 'Payload Mission Related Object' },
    { value: 'Rocket Body Mission Related Object', label: 'Rocket Body Mission Related Object' },
    { value: 'Other Mission Related Object.', label: 'Other Mission Related Object' },
  ]
 

  return (
    <div>
         <Row>
                <Col xs={12}>
                  <h4 style={{ color: '#003247' }}>Spacecraft design</h4>
                </Col>
              </Row>
              <Form>
                <Row className={style.rowForm}>
                  <Col xs={12} sm={4}>
                    <Form.Group>
                      <div style={{ color: '#003247' }}>Mass [kg] </div>
                      <Form.Control 
                      disabled={props.disabled} 
                      value={mass} 
                      isInvalid={(isNaN(parseFloat(mass)) && mass !== '' )||  parseFloat(mass) <= 0}
                      onChange={e => props.onChangeMass(e.target.value, props.index)} 
                      type="text" />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={4}>
                    <Form.Group>
                      <div style={{ color: '#003247' }}>Cross area [m <sup>2</sup>] </div>
                      <Form.Control  
                      disabled={props.disabled} 
                      value={cross} 
                      onChange={e => props.onChangeCross(e.target.value, props.index)} 
                      type="text" 
                      isInvalid={(isNaN(parseFloat(cross)) && cross !== '') || parseFloat(cross) <= 0}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={4}>
                    <div style={{ color: '#003247' }}>Object type </div>
                    <Select
                      isDisabled={props.disabled}
                      className="react-select"
                      classNamePrefix="react-select"
                      value={objectType}
                      onChange={(value) => props.onChangeObjectType(value , props.index)}
                      options={architectureType==='launcher' ? launcherOptions : options}></Select>
                  </Col>
                </Row>
              </Form>
    </div>
  )
}
